import { ApiLegalCountry } from './types';

const legalCountrySet = new Set<string>(Object.values(ApiLegalCountry));

export function isApiLegalCountry(value: string): value is ApiLegalCountry {
  return legalCountrySet.has(value);
}

export function toApiLegalCountry(value: string | null | undefined): ApiLegalCountry | null {
  if (typeof value !== 'string' || !isApiLegalCountry(value)) return null;
  return value;
}
